import Vue from 'vue'
import posthog from 'posthog-js'

// Simple PostHog plugin to make `this.$posthog` (and `$posthog` in templates) available
// and identify the logged in user (if provided via Inertia props).

function initPosthog(user) {
  const key = process.env.MIX_POSTHOG_APP_KEY

  if (!key) {
    // Not configured — do nothing
    console.warn('[PostHog] POSTHOG_APP_KEY nopt set PostHog disabled')
    return posthog
  }

  if (!posthog.__initialized) {
    posthog.init(key, {
    api_host: process.env.MIX_VUE_POSTHOG_HOST || '/ph',
    ui_host: 'https://eu.posthog.com',
    //api_host: 'https://eu.i.posthog.com/',
    capture_pageview: true,
    })
    posthog.__initialized = true

    // Expose a simple reactive flag to know when flags are loaded
    Vue.prototype.$posthogFlags = Vue.observable({ loaded: false })
    posthog.onFeatureFlags(() => {
      Vue.prototype.$posthogFlags.loaded = true
    })
  }

  // Accept either a twitch id string, or a user object with twitch_id 
  let distinctId = null
  if (typeof user === 'string' && user) {
    distinctId = user
  } else if (user && (user.twitch_id )) {
    distinctId = user.twitch_id
  }
  if (distinctId) {
    try {
      posthog.identify(String(distinctId))
      // best-effort; posthog.people may not exist depending on hosting
      if (posthog.people && posthog.people.set) posthog.people.set({ distinctId })
    } catch (e) {
      // ignore identification errors
      /* eslint-disable no-console */
      console.warn('[PostHog] identify failed', e)
    }
  }

  return posthog
}

export default {
  install(VueInstance, { user } = {}) {
    const ph = initPosthog(user)
    VueInstance.prototype.$posthog = ph
    // also allow access via global `$posthog` in templates
    Vue.prototype.$posthog = ph
  },
  initPosthog,
}
